<template>
    <!-- 密码设置 -->
    <div  class="person">
        <div class="tit">
            密码设置
        </div>
        <div class="tixing">
            <i class="el-icon-info"></i>
            {{status == 0?'账号未设置登录密码，请先设置登录密码':'为了您账号安全请先填写当前密码后进行修改'}}
        </div>
        <div v-if="status == 0">
            <div class="info ">
                <div>
                    登陆密码
                </div>
                <el-input show-password v-model="form.password" placeholder="请输入"></el-input>
            </div>
            <div class="info ">
                <div>
                    确认登陆密码
                </div>
                <el-input show-password v-model="form.password_confirm" placeholder="请输入"></el-input>
            </div>
            <el-button class="wan" @click="xiugai">完成</el-button>
        </div>
        <div  v-if="status == 1">
            <div class="info ">
                <div>
                    当前密码
                </div>
                <el-input show-password v-model="formNew.old_password" placeholder="请输入"></el-input>
            </div>
            <div class="info ">
                <div>
                    新密码
                </div>
                <el-input show-password v-model="formNew.password" placeholder="请输入"></el-input>
            </div>
            <div class="info ">
                <div>
                    再次确认新密码
                </div>
                <el-input show-password v-model="formNew.password_confirm" placeholder="请输入"></el-input>
            </div>
            <el-button class="wan" @click="xiugai">完成</el-button>
        </div>
    </div>
</template>
    
<script>
import { changePassword } from "@/api/api";
export default {
    components:{
        
    },
    data() {
        return {
            status:sessionStorage.getItem('has_password')=='true'?1:0,
            form:{
                password:'',
                password_confirm:'',
            },
            formNew:{
                old_password:"",
                password:'',
                password_confirm:'',
            },
            headers:{
                'token':localStorage.getItem('token')
            },
        }
    },
    methods: {
        async xiugai(){
            try {
                const res = await changePassword(
                   this.status == 0 ? this.form : this.formNew,
                   this.headers
                )
                if(res.code == 1){
                    if (this.status == 0) {
                        this.$message({
                            type:'success',
                            message:'密码设置成功'
                        })
                        this.status=1
                        sessionStorage.setItem('has_password',true)
                    }else{
                        this.$message({
                            type:'success',
                            message:'密码修改成功'
                        })
                    }
                }else{
                    this.$message({
                        type:'error',
                        message:res.msg
                    })
                }
                
            } catch (error) {
                console.log('失败',error);
                // this.$message({
                //     type:'error',
                //     message:error
                // })
            }
        }
    }
}
</script>
    
<style style lang="scss" scoped>
.person{
    padding: 32px;
    box-sizing: border-box;

    .tit{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        font-style: normal;
        text-transform: none;
    }

    .tixing{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;
        margin-top: 8px;
    }

    .info{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #606260;
        font-style: normal;
        text-transform: none;

        margin-top: 24px;
    }
    :deep(.el-input){
        width: 280px;
        height: 40px;
        input{
            width: 280px;
            height: 40px;
            background: #F9F9F9;
            border-radius: 8px 8px 8px 8px;
            border: 0;
        }

        margin-right: 48px;
        margin-top: 12px;
    }

    .wan{
        width: 110px;
        height: 40px;
        border-radius: 8px 8px 8px 8px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        font-style: normal;
        text-transform: none;

        border: 0;
        background: #0073F5;
        color: #fff;

        margin-top: 24px;
    }
}
</style>